export default __webpack_public_path__ + "static/media/headerCons-min.4fde0966.jpg";